import React, { useState, } from "react"
import isEmpty from "validator/lib/isEmpty"
import isMobilePhone from "validator/lib/isMobilePhone"
import isNumeric from "validator/lib/isNumeric"
import { useTranslation } from "react-i18next"

import { snapboxOtp } from "services"
import { Button, TextField } from "components"
import classes from "./TnSnapboxOtpStep1.module.scss"

const initialFormErrorState = {
  mobilePhone: ""
}

const TnSnapboxOtpStep1 = props => {
  const { form, setForm, setStep, setOpenOtpModal } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [formError, setFormError] = useState(initialFormErrorState)

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const validate = () => {
    let result = true

    const errors = { ...initialFormErrorState }

    const mobliePhone = `+98${form.mobilePhone.slice(1)}`

    if (isEmpty(mobliePhone)) {
      errors.mobilePhone = t("شماره_موبایل_الزامی_است")
      result = false
    } else if (!isMobilePhone(mobliePhone, ["fa-IR"], { strictMode: true, })) {
      errors.mobilePhone = t("شماره_موبایل_معتبر_نیست")
      result = false
    } else if (!isNumeric(mobliePhone)) {
      errors.mobilePhone = t("شماره_موبایل_معتبر_نیست")
      result = false
    }

    setFormError({ ...errors })

    return result
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (!validate()) return

    setSending(true)
    try {
      await snapboxOtp({
        mobilePhone: form.mobilePhone
      })

      setStep(2)
    } catch (err) {
      console.log(err)

      setSending(false)

      setFormError(t("عملیات_انجام_نشد"))
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className={classes["input"]}>
        <TextField
          withoutSpace
          label={t("موبایل")}
          disabled={sending}
          placeholder={t("شماره_موبایل_تان_را_وارد_کنید")}
          value={form.mobilePhone}
          error={formError.mobilePhone}
          onChange={e =>
            handleChange(e.target.value.trim(), "mobilePhone")
          }
        />
      </div>
      <div className={classes["buttons"]}>
        <Button
          color="danger"
          type="button"
          disabled={sending}
          onClick={() => setOpenOtpModal(false)}
        >
          {t("لغو")}
        </Button>

        <Button
          color="success"
          type="submit"
          loading={sending}
          className={classes["button"]}
        >
          {t("بعدی")}
        </Button>
      </div>
    </form>
  )
}

export default TnSnapboxOtpStep1